import React, { useState,useEffect } from 'react';
import './index.scss';
import {IMGURL} from 'lib/config'
import QueueAnim from "rc-queue-anim";
import { OverPack } from "rc-scroll-anim";
interface IImgsInfo{
  mainImg : string;
  subImg : string;
  xy : {
    x : number;
    y : number;
  }
}
interface IProps {
  dataInfo : {
    title : string;
    data : IImgsInfo[]
  }
}
const Consult = (props: IProps) => {
  const {title,data} = props.dataInfo;
  const [consult,setConsult] = useState(false)
   useEffect(()=>{
    setTimeout(() => {
      setConsult(true)
    }, 500);
   },[])
  return (
    <div className='consult_wrap'>
      <div className="inner">
        <div className="title">{title}</div>

        <OverPack
          playScale={0.1}
          // @ts-ignore
          always={false}
          appear= {consult}
        >
          <QueueAnim
            key="queue"
            type={"bottom"}
            delay={100}
            duration={600}
          >
        <div className="content flex-between"key="content" >

          {
            data.map((item,index)=>{
              return <div className="card" key={index}>
                  <img src={`${IMGURL}${item.mainImg}`} alt="img" className='left_img'/>
                  <img src={`${IMGURL}${item.subImg}`} alt="img" className='right_img'/>
              </div>
            })
          }
        </div>
        </QueueAnim>
        </OverPack>
      </div>
    </div>
  );
};

export default Consult;
